import { Stack, useTheme } from "@mui/material";
import { Clock5 } from "lucide-react";
import type { FC, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DataRowCollapsible } from "web_myplann/Shared/Components/DataRowCollapsible";
import { ShowMoreButton } from "web_myplann/Shared/Components/ShowMoreButton";
import { TotalValue } from "./TotalValue";

const PageResources = Resources.PortfolioDetail;

type ToolRowWrapperProps = {
	label: string;
	totalValue?: string;
	expanded: boolean;
	onToggle: (value: boolean) => void;
	noDivider: boolean;
	portfolioId: number;
	toolIdx: number;
	children: ReactNode;
	showHistoryButton?: boolean;
};

export const ToolRowWrapper: FC<ToolRowWrapperProps> = ({
	label,
	totalValue,
	expanded,
	onToggle,
	noDivider,
	portfolioId,
	toolIdx,
	children,
	showHistoryButton = true,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const navigate = useNavigate();

	const handleShowMore = () => {
		navigate(
			Routing.Portfolio.PortfolioDetailHistory.path(portfolioId, toolIdx),
		);
	};

	return (
		<DataRowCollapsible
			label={label}
			endAdornment={
				totalValue ? <TotalValue value={totalValue} theme={theme} /> : undefined
			}
			expanded={expanded}
			onToggle={onToggle}
			noDivider={noDivider}
		>
			{children}
			{showHistoryButton && (
				<Stack pt={0.4}>
					<ShowMoreButton
						onClick={handleShowMore}
						label={t(PageResources.ToolHistory.button)}
						icon={<Clock5 size={20} color={theme.palette.primary.main} />}
					/>
				</Stack>
			)}
		</DataRowCollapsible>
	);
};
